import GraphicalReportIcon from "../../../components/Common/SvgIcons/ReportIcons/GraphicalReportIcon";
import TabularReportIcon from "../../../components/Common/SvgIcons/ReportIcons/TabularReportIcon";
import AnalyticalReportIcon from "../../../components/Common/SvgIcons/ReportIcons/AnalyticalReportIcon";
import AdoptionReportIcon from "../../../components/Common/SvgIcons/ReportIcons/AdoptionReportIcon";
import SurveyReportIcon from "../../../components/Common/SvgIcons/ReportIcons/SurveyReportIcon";
import AccessReportIcon from "../../../components/Common/SvgIcons/ReportIcons/AccessReportIcon";
import QuizReportIcon from "../../../components/Common/SvgIcons/ReportIcons/QuizReportIcon";
import { FormattedMessage } from "react-intl";

export let reports = {
  name: "Reports",
  // path: `/${localStorage.getItem("tenantName")}/reports`,
  path: (tenantName) => `/${tenantName}/reports`,
  tiles: (navigate, tenantName) => [
    {
      key: 1,
      label: <FormattedMessage id="REPORT_GRAPHICALRPT_TEXT" />,
      color: "#43E57A",
      path: (tenantName) =>
        `/${tenantName}/reports/graphicalReport/userGraphicalReport`,
      onClick: () =>
        navigate(`/${tenantName}/reports/graphicalReport/userGraphicalReport`),
      icon: (fill) => <GraphicalReportIcon fill={fill} />,
    },
    {
      key: 2,
      label: <FormattedMessage id="REPORTCLASS_TEXT" />,
      color: "#A07EFF",
      path: (tenantName) =>
        `/${tenantName}/reports/tabularReport/userTabularReport`,
      onClick: () =>
        navigate(`/${tenantName}/reports/tabularReport/userTabularReport`),
      icon: (fill) => <TabularReportIcon fill={fill} />,
    },
    {
      key: 3,
      label: <FormattedMessage id="ANALYTICAL_REPORTS" />,
      color: "#FF7EB5",
      path: (tenantName) => `/${tenantName}/reports/analyticalReport`,
      onClick: () => navigate(`/${tenantName}/reports/analyticalReport`),
      icon: (fill) => <AnalyticalReportIcon fill={fill} />,
    },
    {
      key: 4,
      label: <FormattedMessage id="Adoption_Report" />,
      color: "#FB9F34",
      path: (tenantName) => `/${tenantName}/reports/adoptionReport`,
      onClick: () => navigate(`/${tenantName}/reports/adoptionReport`),
      icon: (fill) => <AdoptionReportIcon fill={fill} />,
    },
    {
      key: 5,
      label: <FormattedMessage id="SURVEY_REPORT" />,
      color: "#4166F8",
      path: (tenantName) => `/${tenantName}/reports/surveyReport`,
      onClick: () => navigate(`/${tenantName}/reports/surveyReport`),
      icon: (fill) => <SurveyReportIcon fill={fill} />,
    },
    {
      key: 6,
      label: <FormattedMessage id="ACCESS_REPORT" />,
      color: "#7EBEFF",
      path: (tenantName) => `/${tenantName}/reports/accessReport`,
      onClick: () => navigate(`/${tenantName}/reports/accessReport`),
      icon: (fill) => <AccessReportIcon fill={fill} />,
      isVisible: localStorage.getItem("SecurityProviderName") == "SAML2" ? false : true
    },
    {
      key: 7,
      label: <FormattedMessage id="QUIZ_REPORT" />,
      color: "#FF7E7E",
      path: (tenantName) => `/${tenantName}/reports/quizReport`,
      onClick: () => navigate(`/${tenantName}/reports/quizReport`),
      icon: (fill) => <QuizReportIcon fill={fill} />,
    },
  ],
};
